import { toggleMark } from 'prosemirror-commands'
import { MarkType } from 'prosemirror-model'

import { MARK_SHORTCUTS } from '#choo-app/lib/editor/plugins/editor-keymap/index'
import {
  buildShortcutTip,
  keysFromProsemirror,
} from '#hooks/useShortcuts/helpers'
import { selectionContainsMark } from '#util/index'

import { type ToolbarButtonProps } from './ToolbarButton'
import { ToolbarEditorButton } from './ToolbarEditorButton'

interface ToolbarMarkButtonProps extends Omit<ToolbarButtonProps, 'tooltip'> {
  /**
   * The button will toggle this mark on and off, displaying as "active" when
   * the mark is active for the selection
   */
  mark: MarkType
}

/**
 * Display a button connected to the editor state that turns on and off marks
 * for the current text selection. If a keyboard shortcut has been defined
 * through the keymap handler, this will appear in the tooltip.
 */
export const ToolbarMarkButton: React.FC<ToolbarMarkButtonProps> = (props) => {
  'use memo'

  const { mark, label, ...rest } = props
  let tooltip = label
  const shortcut = MARK_SHORTCUTS.get(mark)

  if (tooltip && shortcut) {
    const keys = keysFromProsemirror(shortcut)
    tooltip = `${tooltip} (${buildShortcutTip(keys)})`
  }

  return (
    <ToolbarEditorButton
      tooltip={tooltip}
      command={toggleMark(mark, null, { removeWhenPresent: false })}
      active={(state) => selectionContainsMark(mark, state)}
      {...rest}
    />
  )
}

ToolbarMarkButton.displayName = 'Toolbar.MarkButton'
